import {
  Component,
  OnInit,
  Input,
  inject,
  Output,
  EventEmitter,
} from "@angular/core";
import { NZ_MODAL_DATA, NzModalRef } from "ng-zorro-antd/modal";
import { EventManager, AccountService } from "src/app/core";
import { ToastrService } from "ngx-toastr";
import { ActivatedRoute, Router } from "@angular/router";
import { QueryParams } from "src/app/shared/model/query.params.model";
import { FormBuilder, Validators } from "@angular/forms";
import { MasterDataService } from "src/app/modules/master-data/master-data.service";
import { EditComponent } from "../../../../shared/components/edit.component";
import { ModalComponent } from "../../../../shared/components/modal.component";

@Component({
  selector: "app-add-benefit",
  templateUrl: "./add-benefit.component.html",
  styleUrls: ["./add-benefit.component.scss"],
})
export class AddBenefitComponent
  extends ModalComponent
  implements OnInit
{
  benefitCode: any = '';
  isHasBenefitDetail: boolean = true;
  @Output() itemAdded = new EventEmitter<any>();

  editForm = this.fb.group({
    benefitId: ["", [Validators.required]],
    benefitCode: ["", [Validators.required]],
    benefitDetailCode: [""],
  });
  benefitTypes: any[] = [];
  benefitDetails: any[] = [];
  selectedBenefitDetails: any[] = [];

  constructor(
    public modalRef: NzModalRef,
    private fb: FormBuilder,
    public eventManager: EventManager,
    public router: Router,
    public route: ActivatedRoute,
    private toastService: ToastrService,
    public masterDataService: MasterDataService
  ) {
    super(eventManager, modalRef);
  }
  
  ngOnInit(): void {
    super.ngOnInit();
    this.subscriptions = [
      this.editForm.get('benefitCode').valueChanges
      .subscribe((value) => {
        const findBenefit = this.benefitTypes.find(item => item.code === value);
        if (!findBenefit) {
          return;
        }
        this.editForm.patchValue({
          benefitId: findBenefit.id
        })
      }),
      this.editForm.get('benefitId').valueChanges
      .subscribe((value) => {
        if (!value) {
          return;
        }
        if (this.isHasBenefitDetail) {
          this.queryBenefitDetailTypes(value);
        }
      })
    ];
    // if (!this.benefitCode) {
    //   this.benefitTypes = this.nzModalData.benefitTypes.filter(item => !(this.nzModalData.selectedBenefits || []).some(be => be.code === item.code))
    // }
    this.editForm.patchValue({
      benefitCode: this.benefitCode
    });
    // if (!this.isHasBenefitDetail) {
    //   this.editForm.removeControl('benefitDetailCode');
    // }
  }
  queryBenefitDetailTypes(benefitTypeId) {
    const queryParams = new QueryParams();
    queryParams.searchParams.benefitTypeId = benefitTypeId;
    return this.masterDataService.queryBenefitDetailType(queryParams)
    .subscribe(
      (res: any) => {
        this.benefitDetails = (res.data.rows || []).filter(item => !item.isDisable && !this.selectedBenefitDetails.some(be => be.code === item.code ));
      }
    );
  }
  save() {
    if (this.editForm.invalid || this.disabledButton()) {
      return;
    }
    const findBenefitDetail = this.benefitDetails.find(item => item.code === this.editForm.value.benefitDetailCode);
    this.eventManager.broadcast({
      name: "benefit-added",
      content: {
        benefitCode: this.editForm.value.benefitCode,
        benefitDetail: !findBenefitDetail ? null : {
          code:  this.editForm.value.benefitDetailCode,
          name: findBenefitDetail.name,
        }
      },
    });

    this.cancel();
  }

  queryInvestBenefit(req?: any) {
    const queryParams = new QueryParams();
    queryParams.size = 1000;
    queryParams.pageSize = 1000;
    queryParams.searchParams.groupCode = "INVESTMENT_BENEFIT";
    return this.masterDataService
      .queryBenefitType(queryParams)
      .subscribe((res: any) => {
        this.benefitTypes = res.data.rows || [];
      });
  }
}
